export const UPDATE_PRODUCTS_IN_WISHLIST = /* GraphQL */ `
    mutation updateProductsInWishlist(
        $wishlistId: ID!
        $wishlistItems: [WishlistItemUpdateInput!]!
    ) {
        updateProductsInWishlist(
            wishlistId: $wishlistId
            wishlistItems: $wishlistItems
        ) {
            wishlist {
                id
            }
        }
    }
`
